import { Router } from "@lightningjs/sdk";
import EventEmitter from "eventemitter3";
import GridViewModel from "../components/grid/grid-view-model";
import { ItemNode } from "../components/grid/ItemNode";
import { GRIDTYPE } from "../enum";

export type PreviousVodInfo = {
    vodInfo: ItemNode,
    watchDuration: number,
}

export default class NavigationStack extends EventEmitter {

    continuesStack!: GridViewModel[]

    //Logging info.
    previousVodInfo: PreviousVodInfo | null = null
    currentPlayingTime: any;
    searchHistroyInfo: any;


    constructor() {
        super();
        this.continuesStack = []
    }

    push(grid: GridViewModel) {
        this.continuesStack.push(grid)
    }

    pop() {
        const removingGrid = this.getCurrentGrid()
        removingGrid.destroy()
        this.continuesStack.pop()
    }

    getCurrentGrid() {
        return this.continuesStack[this.continuesStack.length - 1]!
    }

    getCurrentVodInfo() {
        const grid: GridViewModel = this.getCurrentGrid()!
        if (grid) {
            return grid.getFocusedItem();
        }
        return null;
    }

    reset() {
        this.continuesStack = []
        this.previousVodInfo = null
    }

    handleBack() {
        this.pop()
    }

    setPreviousVideoInfo = (videoInfo: ItemNode) => {
        this.previousVodInfo = {
            vodInfo: videoInfo,
            watchDuration: -1,
        }
        //this.previousNodeId = videoInfo.node_id;
    }

    getPreviousVideoInfo = () => {
        return this.previousVodInfo;
    }

    setPreviousVideoWatchDuration = (duration: any) => {
        if (this.previousVodInfo && this.previousVodInfo.watchDuration) {
            if (this.previousVodInfo.vodInfo.feed_type == "live") {
                //this.videoPlayerLive.liveEndTime = Math.round(new Date().getTime() / 1000);
                //this.previousVodInfo.watchDuration = (this.videoPlayerLive.liveEndTime - this.videoPlayerLive.liveStartTime); //in seconds.
            } else {
                if (!duration) return;
                this.previousVodInfo.watchDuration = duration;
            }
        }
    }

    getNonDynamicGrid(): any {
        let cnt = this.continuesStack.length - 1
        let grid
        let exit = false
        while (!exit) {
            grid = this.continuesStack[cnt]!
            if (grid.type !== GRIDTYPE.DYNID) {
                exit = true
            }
            cnt--
        }

        return grid

    }

    resetPreviousVideoInfo = () => {
        this.previousVodInfo = null;
    }

    setCurrentPlayingTime = (currentPlayingTime: any) => {
        this.currentPlayingTime = currentPlayingTime
    }

    getCurrentPlayingTime = () => {
        return this.currentPlayingTime;
    }

    setSearchHistroyInfo = (searchHistroyInfo: any) => {
        this.searchHistroyInfo = searchHistroyInfo;
    }

    getSearchHistroyInfo = () => {
        return this.searchHistroyInfo;
    }

    getCurrentL1=() => {
        let l1= '';
        if(this.continuesStack && this.continuesStack[0] && this.continuesStack[0].channelInfo && this.continuesStack[0].channelInfo.name) {
            l1 = this.continuesStack[0].channelInfo.name.toLowerCase();
        }
        return l1;
    }
}
